// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1656":"b4184ace","1876":"f87245f6"}[chunkId] + ".chunk.css";
};